import React from "react";

import TemplateBlock from "../../../../frontend/templates/_partials/TemplateBlock/Index";
import SliderOverlay from "../../../../frontend/templates/fcb/MatchdaySlider/SliderOverlay";
import { formatFromRatio } from "../../../../frontend/templates/fcb/ResultsNew/helpers";

// The editor canvas paints its own draggable background layers, so the only
// thing this preview contributes is what sits on top of them — and it takes
// that from the template's own SliderOverlay, the same component
// MatchdaySlider/Index.jsx renders. There is no second copy of the markup to
// keep in step any more: the preview and the exported image are the same tree.
//
// It is rendered at the template's real pixel size inside `.template-container`,
// which the editor stylesheet then scales down (0.319 / 0.409) per format —
// the same approach resultContent.js uses.
const FCBSlider1Content = ({ data, jersey, hasCLStars, isDfbPokal, ratio }) => {
    const format = formatFromRatio(ratio);

    return (
        <div className={`comp-template-preview result-template-preview f-${format}`}>
            <div className="template-container">
                <div className="T_fcb_matchday_slider_1" id={`${data?.template_name ?? ""}_${data?.uuid}`}>
                    <TemplateBlock>
                        {/* Empty of layers — the editor draws those itself — but
                            kept so the overlay stacks against the same box it
                            does in the export. */}
                        <div className={"custom-background-container"}>
                            <div className={"custom-background"}></div>
                        </div>
                        <SliderOverlay
                            data={data}
                            jersey={jersey}
                            hasCLStars={hasCLStars}
                            isDfbPokal={isDfbPokal}
                        />
                    </TemplateBlock>
                </div>
            </div>
        </div>
    );
};

export default FCBSlider1Content;
